<p-dialog
    [(visible)]="displayFormDialog"
    [style]="{ width: '1000px' }"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    (onHide)="onFormDialogClosed()"
    [header]="selectedActividad ? 'Editar Actividad' : 'Nueva Actividad'"
>
    <app-actividad-form-dialog
        [model]="selectedActividad"
        [visible]="displayFormDialog"
        (visibleChange)="onFormDialogClosed($event)"
        [numeroProceso]="proceso"
    ></app-actividad-form-dialog>
</p-dialog>

<div class="card-header mb-4">
  <div class="title-section d-flex align-items-center gap-3">
    <h2 class="header-title mb-0">Actividades de la ruta crítica {{ proceso }}</h2>
  </div>
  <div class="search-section">
    <div class="button-section">
      <span class="p-input-icon-left search-input">
        <i class="pi pi-search"></i>
        <input pInputText type="text" (input)="onFilter($event)" placeholder="Buscar..." class="p-inputtext-sm" appPermissionControl="P250K0001">
      </span>
      <button mat-flat-button class="btn-new" (click)="openCreate()" appPermissionControl="P250B0001">
        <mat-icon>add</mat-icon>
        Nuevo
      </button>
      <button mat-flat-button (click)="onDialogClosed()" class="btn-delete" appPermissionControl="P250B0002">
        <mat-icon>close</mat-icon>
        Cerrar
      </button>
    </div>
  </div>
</div>
<p-table [value]="actividades" [columns]="displayedColumns" [paginator]="true" [rows]="rows" [first]="first"
  [totalRecords]="totalRecords" [showCurrentPageReport]="true" [rowsPerPageOptions]="[5, 10, 20]"
  [scrollable]="true" [scrollHeight]="'500px'" styleClass="p-datatable-gridlines"
  [resizableColumns]="true" [autoLayout]="true" responsiveLayout="scroll" [loading]="loading"
  [globalFilterFields]="['actividad','descripcion','dependencia','tipo']" (onPage)="onPage($event)"
  currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros" appPermissionControl="P250T0001">
  <ng-template pTemplate="header">
    <tr>
      <th *ngFor="let col of displayedColumns" class="th-prime" appPermissionControl="P250C0001">
        {{ col.header }}
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-rowData>
    <tr>
      <td *ngFor="let col of displayedColumns" class="td-prime">
        <ng-container [ngSwitch]="col.field">
          <ng-container *ngSwitchCase="'acciones'">
            <div class="d-flex gap-2 justify-content-center">
              <button pButton icon="pi pi-eye"
                class="p-button-rounded p-button-info p-button-text"
                pTooltip="Editar"
                (click)="openEdit(rowData)" appPermissionControl="P250B0003"></button>
              <button pButton icon="pi pi-trash"
                class="p-button-rounded p-button-danger p-button-text"
                pTooltip="Eliminar"
                (click)="delete(rowData)" appPermissionControl="P250B0004"></button>
            </div>
          </ng-container>
          <ng-container *ngSwitchDefault>
            {{ rowData[col.field] }}
          </ng-container>
        </ng-container>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="4" class="text-center td-prime">
        <span *ngIf="actividades.length === 0 && !loading">No hay datos para mostrar</span>
        <p-progressSpinner *ngIf="loading" styleClass="w-4rem h-4rem" strokeWidth="8"
          fill="var(--surface-ground)" animationDuration=".5s"></p-progressSpinner>
      </td>
    </tr>
  </ng-template>
</p-table>

<p-toast position="bottom-right"></p-toast>
<style>
.label-proceso {
  font-size: 0.95rem;
  color: #6c757d;
  margin-left: 1rem;
  margin-right: 0.5rem;
}
.proceso-input {
  width: 120px;
  background: #e0e0e0 !important;
  color: #555 !important;
  opacity: 1 !important;
}
</style> 